import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  do_no: string;
  sc_no: string;
  do_date: string | null;
  customer_code: string;
  customer_name: string;
  dept_code: string;
  dept_name: string;
  currency: string;
  untaxed_amount: number;
  taxed_amount: number;
  tax_amount: number;
  approval_status: string;
  detail_count: number;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  do_no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ApprovalFilter {
  doStart: string;
  doEnd: string;
}

// FC120 detail type (matches backend models)
export interface FC120Detail {
  fc120_01: string;
  fc120_10: string;
  fc120_11: string | null;
  fc120_12: string;
  fc120_17: string;
  fc120_18: string;
  fc120_20: number;
  fc120_201: number;
  fc120_16: number;
  fc120_27: number;
  fc120_80: string;
  details?: FC121Detail[];
}

export interface FC121Detail {
  fc121_01: string;
  fc121_02: number;
  fc121_10: string;
  fc121_11: string;
  fc121_12: string;
  fc121_13: string;
  fc121_15: string;
  fc121_16: number;
  fc121_18: number;
  fc121_19: number;
  batches?: FC122Batch[];
}

export interface FC122Batch {
  fc122_01: string;
  fc122_02: number;
  fc122_03: number;
  fc122_11: string;
  fc122_12: number;
  fc122_14: string;
}

// ============================================================
// API methods
// ============================================================

export const c504Api = {
  // GET /api/pwc504f1/pending?doStart=&doEnd=
  async getPending(filter: ApprovalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/pwc504f1/pending', {
      params: {
        doStart: filter.doStart,
        doEnd: filter.doEnd,
      },
    });
    return res.data;
  },

  // GET /api/pwc504f1/:id
  async getDetail(doNo: string): Promise<FC120Detail> {
    const res = await apiClient.get(`/api/pwc504f1/${doNo}`);
    return res.data;
  },

  // POST /api/pwc504f1/approve
  async approve(doNos: string[], comment?: string): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwc504f1/approve', {
      do_nos: doNos,
      confirmed: true,
      comment: comment || '',
    });
    return res.data;
  },

  // POST /api/pwc504f1/reject
  async reject(doNos: string[], comment?: string): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwc504f1/reject', {
      do_nos: doNos,
      confirmed: true,
      comment: comment || '',
    });
    return res.data;
  },
};
